import { OrderedMap, RecordOf, Set } from 'immutable';

// Если у вас есть стейт, который обновляется по какой-то причине (раз в N сек, по нажатию на какую-то кнопку и т.д.)
// И при этом с бэка приходят примерно одинаковые данные, то нам не нужно обновлять весь стейт
// Нужно обновить только измененный кусок.

type ImmutableRecord = RecordOf<Record<string, unknown>>;

export const createEntityMapHandler = <
  State extends OrderedMap<(string | number | symbol), ImmutableRecord>,
  EntryDto extends Record<string, unknown>,
  T extends (value: EntryDto) => ImmutableRecord
>(indexFieldName: string, createEntry: T) => (
    (state: State, payload: EntryDto[]): State => {
      // Формируем массив идентификаторов
      const ids = Set(payload.map((entity) => entity[indexFieldName]));

      // Проверяем, есть ли этот айдишник в стейте. Если нет, значит элемент был удален
      const newState = state.filter((entry) => ids.has(entry[indexFieldName]));

      // Если элементов в payload стало меньше, то нужно удалить их из state
      if (newState.size < state.size) {
        state = newState;
      }

      // Добавляем новый элемент или обновляем уже существующий
      payload.forEach((entity) => {
        const id = entity[indexFieldName] as keyof EntryDto;
        const newEntry = createEntry(entity);

        if (!state.has(id) || !state.get(id)?.equals(newEntry)) {
          state = state.set(id, newEntry);
        }
      });

      return state;
    }
  );
